export const user = state => state.user;

export const courseList = state => state.courseList;

export const activityList = state => state.activityList;

export const activityCourseList = state => state.activityCourseList;

export const schoolList = state => state.schoolList;

export const coachList = state => state.coachList;

export const orderList = state => state.orderList;

export const stockList = state => state.stockList;

export const studentList = state => state.studentList;

export const certList = state => state.certList;

export const uploadCoachList = state => state.uploadCoachList;

export const course = state => state.course;

export const activity = state => state.activity;

export const school = state => state.school;

export const coach = state => state.coach;

export const cert = state => state.cert;